import { useState, useEffect } from 'react';

/**
 * Custom hook for responsive media queries.
 * @param {string} query - A CSS media query string, e.g. '(max-width: 768px)'
 * @returns {boolean} Whether the media query currently matches.
 */
export const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);
    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, [query]);
    return matches;
};
